module.exports = __webpack_public_path__ + "hyperion-v2-static/img/seerist_app_icon_144x144.65800202.png";